import React, { useState } from "react";
import PropTypes from "prop-types";

import { AlertBar } from "./AlertBar";
import { ActingAsBar } from "./ActingAsBar";
import { Navigation, SlideoutContainer } from "./Layout/Navigation";
import { SkipToContent, SkipToDestination } from "./SkipToContent";
import { MainColumn } from "./MainColumn";

import { SiteHeader } from "./Layout/SiteHeader";
import { Footer } from "./Layout/Footer";
import { MainContainer } from "./Layout/MainContainer";

export function Layout({ children }) {
  const skipToRef = React.createRef();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <MainContainer>
      <SkipToContent reference={skipToRef} />
      <SiteHeader menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <ActingAsBar />
      <SlideoutContainer>
        <Navigation menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
        <MainColumn>
          <AlertBar />
          <SkipToDestination reference={skipToRef}>
            {children}
          </SkipToDestination>
        </MainColumn>
      </SlideoutContainer>
      <Footer />
    </MainContainer>
  );
}

Layout.propTypes = {
  children: PropTypes.node,
};
